import { InjectionToken } from '@angular/core';
import { HttpErrorMessagesExtractor } from '../models/http-error-messages-extractor';

export const HTTP_ERROR_MESSAGES_EXTRACTOR: InjectionToken<HttpErrorMessagesExtractor> =
  new InjectionToken<HttpErrorMessagesExtractor>('HTTP_MESSAGES_EXTRACTOR');
